import { Menu, ActionIcon } from '@mantine/core'
import { IconMenu2, IconHelp, IconHome, IconRocket, IconDeviceMobile } from '@tabler/icons-react'
import { useNavigate, useLocation } from 'react-router-dom'

export function HamburgerMenu() {
    const navigate = useNavigate()
    const location = useLocation()

    return (
        <Menu shadow="md" width={220} position="bottom-start" zIndex={9999}>
            <Menu.Target>
                <ActionIcon variant="subtle" size="lg" aria-label="Menu">
                    <IconMenu2 size={20} />
                </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Item
                    leftSection={<IconHome size={16} />}
                    onClick={() => navigate('/')}
                    disabled={location.pathname === '/'}
                >
                    Home
                </Menu.Item>

                <Menu.Divider />

                <Menu.Label>Help</Menu.Label>
                <Menu.Item
                    leftSection={<IconHelp size={16} />}
                    onClick={() => navigate('/help')}
                    disabled={location.pathname === '/help'}
                >
                    Help Center
                </Menu.Item>
                <Menu.Item
                    leftSection={<IconRocket size={16} />}
                    onClick={() => navigate('/help/getting-started')}
                    disabled={location.pathname === '/help/getting-started'}
                >
                    Getting Started
                </Menu.Item>
                <Menu.Item
                    leftSection={<IconDeviceMobile size={16} />}
                    onClick={() => navigate('/help/add-to-home-screen')}
                    disabled={location.pathname === '/help/add-to-home-screen'}
                >
                    Add to Home Screen
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    )
} 